<div class="loading-spinner-wrapper">
  <div class="spinner-border app-loading-spinner" role="status" aria-label="Loading">
    <span class="visually-hidden">Loading</span>
  </div>
</div>
